"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialize = initialize;
exports.constants = exports.exception = exports.timing = exports.autoCapture = exports.click = exports.capture = exports.modalView = exports.pageView = void 0;

var _reactGa = _interopRequireDefault(require("react-ga"));

var constants = _interopRequireWildcard(require("./constants/analytics"));

exports.constants = constants;

var logger = _interopRequireWildcard(require("./logger"));

function getDocumentHeight() {
  if (!global.window || !global.window.document || !global.window.document.getElementsByTagName) return null;
  var html = global.window.document.getElementsByTagName('html')[0];
  var body = global.window.document.getElementsByTagName('body')[0];
  return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
}

function getDocumentWidth() {
  if (!global.window || !global.window.document || !global.window.document.getElementsByTagName) return null;
  var html = global.window.document.getElementsByTagName('html')[0];
  var body = global.window.document.getElementsByTagName('body')[0];
  return Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
}

var initialized = false;

function initialize(trackingID) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  logger.info({
    id: 'Google Analytics',
    trackingID: trackingID,
    options: options
  });

  _reactGa["default"].initialize(trackingID, options);

  initialized = true;
}

var track = function track(cb) {
  return cb();
};
/**
 * Tracks a page view
 *
 * @param {String} path Path to the page
 */


var pageView = function pageView(path) {
  if (!initialized) return;
  track(function () {
    try {
      _reactGa["default"].pageview(path);
    } catch (error) {
      logger.error({
        description: 'Failed to track page view',
        args: [path],
        error: error
      });
    }
  });
};
/**
 * Tracks a modal view
 *
 * @param {String} name Name of the modal
 */


exports.pageView = pageView;

var modalView = function modalView(name) {
  if (!initialized) return;
  track(function () {
    try {
      _reactGa["default"].modalview(name);
    } catch (error) {
      logger.error({
        description: 'Failed to track modal view',
        args: [name],
        error: error
      });
    }
  });
};
/**
 * Event triggered by users action
 *
 * @param {String} category Generic category
 * @param {String} action The action taken
 * @param {String} label (optional) Further categorisation
 * @param {Integer} value (optional) if value is a number then set here
 */


exports.modalView = modalView;

var capture = function capture(_ref) {
  var category = _ref.category,
      action = _ref.action,
      label = _ref.label,
      value = _ref.value;
  if (!initialized) return;
  track(function () {
    try {
      _reactGa["default"].event({
        category: category,
        action: action,
        label: label,
        value: value
      });
    } catch (error) {
      logger.error({
        description: 'Failed to track capture',
        args: [{
          category: category,
          action: action,
          label: label,
          value: value
        }],
        error: error
      });
    }
  });
};

exports.capture = capture;

var getRelativeCoordinates = function getRelativeCoordinates(event) {
  var documentHeight = getDocumentHeight();
  var documentWidth = getDocumentWidth();
  if (documentHeight === null || documentWidth === null) return {
    x: null,
    y: null
  };
  return {
    x: (event.pageX / documentWidth).toFixed(2),
    y: (event.pageY / documentHeight).toFixed(2)
  };
};
/**
 * Click event
 *
 * @param {String} category Generic category
 * @param {String} label (optional) Further categorisation
 * @param {Event} event (optional) Click event
 */


var click = function click(_ref2) {
  var category = _ref2.category,
      label = _ref2.label,
      event = _ref2.event;
  if (!initialized) return;
  track(function () {
    try {
      capture({
        category: category,
        label: label,
        action: 'click'
      });
      if (event) capture({
        category: category,
        label: JSON.stringify(getRelativeCoordinates(event)),
        action: 'click_coordinates'
      });
    } catch (error) {
      logger.error({
        description: 'Failed to track click',
        args: [{
          category: category,
          label: label
        }],
        error: error
      });
    }
  });
};
/**
 * Event not triggered by a user action
 *
 * @param {String} category Generic category
 * @param {String} action The action taken
 * @param {String} label (optional) Further categorisation
 * @param {Integer} value (optional) if value is a number then set here
 */


exports.click = click;

var autoCapture = function autoCapture(_ref3) {
  var category = _ref3.category,
      action = _ref3.action,
      label = _ref3.label,
      value = _ref3.value;
  if (!initialized) return;
  track(function () {
    try {
      _reactGa["default"].event({
        category: category,
        action: action,
        label: label,
        value: value,
        nonInteraction: true
      });
    } catch (error) {
      logger.error({
        description: 'Failed to track auto capture',
        args: [{
          category: category,
          action: action,
          label: label,
          value: value
        }],
        error: error
      });
    }
  });
};
/**
 * Captures a timing
 *
 * @param {String} category Generic category of timing, e.g. network_requests
 * @param {String} label (optional) further categorisation
 * @param {Integer} value Time in ms
 * @param {String} variable Name of the timing variable
 */


exports.autoCapture = autoCapture;

var timing = function timing(_ref4) {
  var category = _ref4.category,
      label = _ref4.label,
      value = _ref4.value,
      variable = _ref4.variable;
  if (!initialized) return;
  track(function () {
    try {
      _reactGa["default"].timing({
        category: category,
        label: label,
        value: value,
        variable: variable
      });
    } catch (error) {
      logger.error({
        description: 'Failed to track timing',
        args: [{
          category: category,
          label: label,
          value: value,
          variable: variable
        }],
        error: error
      });
    }
  });
};
/**
 * Tracks an exception
 *
 * @param {String} description Description of the exception
 * @param {Boolean} fatal Was the exception fatal?
 * @param {Array} args Args on the function which threw the error
 * @param {Error} error The exception (error) object
 */


exports.timing = timing;

var exception = function exception(_ref5) {
  var description = _ref5.description,
      fatal = _ref5.fatal,
      args = _ref5.args,
      error = _ref5.error;
  if (!initialized) return;
  track(function () {
    try {
      _reactGa["default"].exception({
        description: description,
        fatal: fatal
      });
    } catch (err) {
      console.error('failed to track exception', [{
        description: description,
        fatal: fatal,
        args: args,
        error: error
      }], err);
    }
  });
};

exports.exception = exception;